<template>
    <div class="slide">
        <TriviaCard :currentTrivia="currentTrivia" :title="questions.question.title"
                    :answers="questions.question.answers"
                    :correctAnswer="questions.question.correctAnswer"
                    :nextRoute="nextRoute"
                    :current="4"
                    :total="5" />
    </div>
</template>

<script>
import TriviaCard from '@/components/TriviaCard.vue'

export default {
    name: 'trivia',
    components: {
        TriviaCard,
    },
    data() {
        return {
            nextRoute: "trivia-19",
            currentTrivia: 18,
            questions: {
                question: {
                    "title": "True or False: It is standard interview procedure to have some distractions in the room; this distracts the subject from fabricating their story",
                    "answers": [
                        {"key": "A", "answer": "True"},
                        {"key": "B", "answer": "False"},
                    ],
                    "correctAnswer": ["B"]
                }
            }
        }
    },
  mounted() {
    window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
  }
}
</script>

<style lang="scss" scoped>

</style>
